<template>
  <HubContainer id="loyaltyHub">

    <template v-if="!exactlyDistributor && ((isBranchLevel && moduleActivated.loyalty ) || (isCompanyLevel && isLoyaltyActivated))">
      <HubSection large icon="icon/hub/transactions.svg"
                  :title="$t('loyalty_transactions.list')"
                  :description="$t('loyalty_transactions.list_description')"
                  :buttonAction="goToLoyaltyTransactions">
      </HubSection>

      <HubSection large icon="icon/hub/customer-accounts.svg"
                  :title="$t('loyalty_accounts.list')"
                  :description="$t('loyalty_accounts.list_description')"
                  :buttonAction="goToLoyaltyAccounts">
      </HubSection>

      <HubSection large icon="icon/hub/gift-cards.svg" v-if="isGiftCardActivated"
                  :title="$t('gift_card.card_list')"
                  :description="$t('gift_card.card_list_description')"
                  :buttonAction="goToGiftCards">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "loyaltyHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "loyalty.title";
      this.$store.state.pageIcon = "icon/nav/loyalty.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }

      if (this.$route.query.company) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      isGiftCardActivated() {
        return this.branch && this.branch.loyaltyConfig && this.branch.loyaltyConfig.data && this.branch.loyaltyConfig.data.giftCardActivated;
      },
      isLoyaltyActivated() {
        return this.branch && this.branch.loyaltyConfig && this.branch.loyaltyConfig.activated;
      },
      isBranchLevel() {
        return this.$route.query.branch;
      },
      isCompanyLevel() {
        return this.$route.query.company;
      },
    },

    methods: {
      goToLoyaltyTransactions() {
        this.$router.push(this.$router.buildContext("/loyalty-transactions"));
      },
      goToLoyaltyAccounts() {
        this.$router.push(this.$router.buildContext("/loyalty-accounts"));
      },
      goToGiftCards() {
        this.$router.push(this.$router.buildContext("/gift-cards"));
      },
    }
  }
</script>